import { Delete, Get, Post, Put } from "./api-base"
import { urls } from "./urls.constants";
import Axios from "axios";

export const postRecoverPassword = async (params) => {
  return await Axios.post(`${urls.RECOVER_PASSWORD}`, params, { headers: { "Content-Type": " application/json" } });
}

export const getScheduleBalance = () => {
  return Get(`${urls.SCHEDULE_BALANCE}`);
}

export const getScheduleEvents = (date) => {
  return Get(`${urls.SCHEDULE_EVENTS}/${date}`);
}

export const getScheduleTransactions = (params) => {
  const queryString = new URLSearchParams();

  Object.entries(params).forEach(([key, value]) => {
    if (Array.isArray(value)) {
      value.forEach(v => queryString.append(key, v));
    } else if (value !== undefined && value !== null) {
      queryString.append(key, value);
    }
  });
  return Get(`${urls.SCHEDULE_TRANSACTIONS}?${queryString.toString()}`);
}

export const getTransactionsLatest = (params) => {
  return Get(`${urls.TRANSACTION_LATEST}`, params);
}

export const getTransactionsSummary = (params) => {
  return Get(`${urls.TRANSACTION_SUMMARY}`, params);
}

export const getTransactionDetails = (paymentId) => {
  return Get(`${urls.TRANSACTION}/${paymentId}`);
}

export const getReportsList = (params) => {
  return Get(`${urls.REPORTS}`, params);
}

export const postReports = (params) => {
  return Post(`${urls.REPORTS}`, params);
}

export const getReportDownload = (reportId) => {
  return Get(`${urls.REPORTS}/${reportId}/download`);
}

export const postChangePassword = (params) => {
  return Post(`${urls.CHANGE_PASSWORD}`, params);
}

export const getEntries = (params) => {
  return Get(urls.ENTRIES_PAGINATED, params);
}

export const getBalance = () => {
  return Get(urls.BALANCE);
}

export const requestAllWithdraw = () => {
  return Post(`${urls.WITHDRAW}/all`);
}

// {automatic: boolean}: se o saque deste seller é feito pelo saque automático diário.
// Decidido no accounts pela mesma regra que recusa o saque manual com 403.
export const getAutoWithdrawStatus = () => {
  return Get(`${urls.WITHDRAW}/auto-status`);
}

export const sellersBalancesTotal = () => {
  return Get(`${urls.SELLERS_BALANCES_TOTAL}`);
}

export const sellersBalances = ({page, pageSize, orderBy, order, search}) => {
  return Get(`${urls.SELLERS_BALANCES}?page=${page}&pageSize=${pageSize}&orderBy=${orderBy}&order=${order}${search ? `&search=${search}` : ''}`);
}

export const getUsers = (params) => {
  return Get(`${urls.USERS}`, params);
}

export const postUsers = (params) => {
  return Post(`${urls.USERS}`, params)
}

export const getUserById = (userId) => {
  return Get(`${urls.USERS}/${userId}`)
}

export const putUser = (userId, data) => {
  return Put(`${urls.USERS}/${userId}`, data)
}

export const getAvailableUsers = () => {
  return Get(urls.AVAILABLE_USERS);
}

export const listSubsellers = (params) => {
  return Get(urls.SUBSELLERS, params);
}

export const getSubseller = (id) => {
  return Get(`${urls.SUBSELLERS}/${id}`);
}

export const postSubseller = ({id, data}) => {
  return Post(`${urls.SUBSELLERS}/${id}`, data);
}

export const getSchedules = (params) => {
  return Get(urls.SCHEDULES, params);
};

export const getSchedulesStats = () => {
  return Get(urls.SCHEDULES_STATS);
};

export const getPaymentClients = () => {
  return Get(`${urls.PAYMENT_ORDERS}/portal/clients`);
}

export const getPaymentBatches = ({page, pageSize}) => {
  return Get(`${urls.PAYMENT_ORDERS}/portal/batches?page=${page}&page_size=${pageSize}`);
}

export const getPaymentBatch = ({id}) => {
  return Get(`${urls.PAYMENT_ORDERS}/portal/batches/${id}`);
}

export const getPaymentBatchOrders = ({id, page, pageSize}) => {
  return Get(`${urls.PAYMENT_ORDERS}/portal/batches/${id}/orders?page=${page}&page_size=${pageSize}`);
}

export const executeBatch = ({id}) => {
  return Post(`${urls.PAYMENT_ORDERS}/portal/batches/${id}/execute`);
}

export const closeBatch = ({id}) => {
  return Post(`${urls.PAYMENT_ORDERS}/portal/batches/${id}/close`);
}

export const approveOrder = ({id, batchId}) => {
  return Post(`${urls.PAYMENT_ORDERS}/portal/batches/${batchId}/orders/${id}/approve`);
}

export const denyOrder = ({id, batchId}) => {
  return Post(`${urls.PAYMENT_ORDERS}/portal/batches/${batchId}/orders/${id}/deny`);
}

export const approveAllOrder = ({id}) => {
  return Post(`${urls.PAYMENT_ORDERS}/portal/batches/${id}/approve`);
}

export const denyAllOrder = ({id}) => {
  return Post(`${urls.PAYMENT_ORDERS}/portal/batches/${id}/deny`);
}

export const simBankListOrders = ({page, pageSize}) => {
  return Get(`${urls.PAYMENT_ORDERS}/portal/sim/orders?page=${page}&page_size=${pageSize}`);
}

export const simBankExecuteOrder = ({id, payload}) => {
  return Post(`${urls.PAYMENT_ORDERS}/portal/sim/orders/${id}/execute`, payload);
}

export const getPaymentsPlan = (token, page, pageSize, status, search, sort, orderBy) => {
  const url = new URL(`${urls.PAYMENT_PLAN}/plans?page=${page}&pageSize=${pageSize}&_sort=${sort}&_order=${orderBy}`);

  if (status !== 'all') {
    url.searchParams.append("status", status);
  }

  if(search !== '') {
    url.searchParams.append("search", search);
  }

  return Get(url.toString(), null, {
     'Authorization': `Bearer ${token}`
  });
};

export const getPaymentsPlanRead = (id, token) => {
  return Get(`${urls.PAYMENT_PLAN}/plans/${id}`, null, {
    'Authorization': `Bearer ${token}`
  });
};

export const getPaymentPlanInstallments = (id, token) => {
  return Get(`${urls.PAYMENT_PLAN}/plans/${id}/installments`, null, {
    'Authorization': `Bearer ${token}`
  });
};

export const getPaymentPlanInstallmentDetails = (id, num, token) => {
  return Get(`${urls.PAYMENT_PLAN}/plans/${id}/installments/${num}`, null, {
    'Authorization': `Bearer ${token}`
  });
};

export const postPaymentMethod = (id, num, data, token) => {
  return Post(`${urls.PAYMENT_PLAN}/plans/${id}/installments/${num}/payment-method`, data, {
    'Authorization': `Bearer ${token}`
  });
};

export const getPixStatus = (id) => {
  return Get(`${urls.PAYMENT_PLAN_PUBLIC}/${id}/pix/status`);
};

export const deleteDisableBoleto = (id, token) => {
  return Delete(`${urls.PAYMENT_PLAN}/plans/${id.id}`, {
    'Authorization': `Bearer ${token}`
  });
};

export const uploadUrlFileReconciliation = (data, token) => {
  return Get(`${urls.RECONCILIATION}/jobs/upload-url`, data, {
    'Authorization': `Bearer ${token}`
  })
}

export const saveFileReconciliation = (data, token) => {
  return Post(`${urls.RECONCILIATION}/jobs`, { file_key: data }, {
    'Authorization': `Bearer ${token}`
  })
}

export const getReconciliations = (token, page, pageSize) => {
  return Get(`${urls.RECONCILIATION}/jobs?page=${page}&pageSize=${pageSize}`, null, {
    'Authorization': `Bearer ${token}`
  });
}

export const getReconciliation = (token, id) => {
  return Get(`${urls.RECONCILIATION}/jobs/${id}`, null, {
    'Authorization': `Bearer ${token}`
  });
}

export const getReconciliationDays = (token, id) => {
  return Get(`${urls.RECONCILIATION}/jobs/${id}/days`, null, {
    'Authorization': `Bearer ${token}`
  });
}

export const getReconciliationDayDetails = (token, id) => {
  return Get(`${urls.RECONCILIATION}/days/${id}`, null, {
    'Authorization': `Bearer ${token}`
  });
}
export const getReconciliationsDaysList = (token, page, pageSize, dayMin, dayMax) => {
  return Get(`${urls.RECONCILIATION}/days?page=${page}&pageSize=${pageSize}&dayMin=${dayMin}&dayMax=${dayMax}`, null, {
    'Authorization': `Bearer ${token}`
  });
}

export const getWebhooks = (token) => {
  return Get(`${urls.RECONCILIATION}/webhooks/mine`, null, {
    'Authorization': `Bearer ${token}`
  });
}

export const listWebhooksInvocations = (token, page, pageSize) => {
  return Get(`${urls.RECONCILIATION}/webhooks/mine/invocations?page=${page}&pageSize=${pageSize}`, null, {
    'Authorization': `Bearer ${token}`
  });
}

export const putWebhooks = (token, data) => {
  return Put(`${urls.RECONCILIATION}/webhooks/mine`, data, {
    'Authorization': `Bearer ${token}`
  });
}

export const deleteWebhooks = (token) => {
  return Delete(`${urls.RECONCILIATION}/webhooks/mine`, null, {
    'Authorization': `Bearer ${token}`
  });
}

export const getWebhookNotifications = (token, page, pageSize, search) => {
  const url = new URL(`${urls.WEBHOOK}/notifications?page=${page}&pageSize=${pageSize}`);

  if(search !== '') {
    url.searchParams.append("search", search);
  }

  return Get(url.toString(), null, {
     'Authorization': `Bearer ${token}`
  });
}

export const getWebhookNotificationsDetails = (token, id) => {
  return Get(`${urls.WEBHOOK}/notifications/${id}`, null, {
    'Authorization': `Bearer ${token}`
  });
}

export const getVideos = (token, params) => {
  return Get(urls.VIDEOS, params, {
    'Authorization': `Bearer ${token}`
  });
}

export const getVideo = (token, id) => {
  return Get(`${urls.VIDEOS}/${id}`, null, {
    'Authorization': `Bearer ${token}`
  });
}

export const getSummaryTransactionsAdmin= (params) => {
  return Get(`${urls.TRANSACTION_SUMMARY_ADMIN}`, params);
}

export const getBoletos = (
  token,
  page,
  pageSize,
  status,
  search,
  sortField,
  orderDir,
  dateFrom,
  dateTo
) => {
  const url = new URL(`${urls.PAYMENT_PLAN}/boletos`);
  url.searchParams.set('page', page ?? 0);
  url.searchParams.set('pageSize', pageSize ?? 10);

  if (sortField) url.searchParams.set('_sort', sortField);
  if (orderDir)  url.searchParams.set('_order', String(orderDir).toUpperCase());

  if (status && status !== 'all') url.searchParams.set('status', status);
  if (search && search.trim())   url.searchParams.set('search', search.trim());


  if (dateFrom) url.searchParams.set('initialDate', dateFrom);
  if (dateTo)   url.searchParams.set('endDate', dateTo);

  return Get(url.toString(), null, { Authorization: `Bearer ${token}` });
};

export const getBoletosSummary = (
  token,
  dateFrom,
  dateTo,
  search
) => {
  const url = new URL(`${urls.PAYMENT_PLAN}/boletos-summary`);
  if (dateFrom) url.searchParams.set('initialDate', dateFrom);
  if (dateTo)   url.searchParams.set('endDate', dateTo);
  if (search && search.trim())    url.searchParams.set('search', search.trim());

  return Get(url.toString(), null, { Authorization: `Bearer ${token}` });
};

export const getBalanceAdmin = () => {
  return Get(urls.BALANCE_ADMIN);
}

export const getSummaryPaymentPlan = (token, params) => {
  return Get(`${urls.PAYMENT_PLAN_SUMMARY}`, params, {
    'Authorization': `Bearer ${token}`
  });
}

export const getFaqs = (token, page, pageSize) => {
  const url = new URL(`${urls.FAQ}?page=${page}&pageSize=${pageSize}`);

  return Get(url.toString(), null, {
     'Authorization': `Bearer ${token}`
  });
}

export const postFaq = (data, token) => {
  return Post(`${urls.FAQ}`, data, {
    'Authorization': `Bearer ${token}`
  });
}

export const putFaq = (id, data, token) => {
  return Put(`${urls.FAQ}/${id}`, data, {
    'Authorization': `Bearer ${token}`
  });
}

export const deleteFaq = (id, token) => {
  return Delete(`${urls.FAQ}/${id}`, null, {
    'Authorization': `Bearer ${token}`
  });
}

export const getFaqsClient = () => {
  return Get(`${urls.FAQ_CLIENT}`);
}
